module.exports = __webpack_public_path__ + "static/media/slide2-myschoolok.502bd824.png";